import { createUseStyles } from '../../theme/theming';

const useSectionStyles = createUseStyles((theme) => ({
  section: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '64px 128px 24px 128px',
    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    },
    background: '#f9f9f9'
  },
  sectionNoBranding: {
    paddingBottom: '0px'
  },
  upperContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 0 20px 0',
    width: '100%',
    borderBottom: '1px solid #E1EAF6',
    alignItems: 'flex-start'
  },
  upperContainerNoBranding: {
    borderBottom: '0px'
  },
  upperContainerItem1: {
    width: '33%',
    display: 'flex',
    justifyContent: 'flex-start'

    // '& img': { maxHeight: '55px' }
  },

  upperContainerItem1Img: {
    maxHeight: '55px',
    paddingBottom: '84px',
    position: 'relative',
    width: '33%'
  },
  upperContainerItem2: {
    width: '33%'
  },
  upperContainerItem3: {
    width: '33%',
    display: 'flex',
    justifyContent: 'end',
    flexWrap: 'wrap',
    paddingBottom: '52px'
  },
  cardHeading: {
    fontSize: '16px',
    color: theme?.palette?.font?.tertiary,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  addressContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginBottom: '16px'
  },
  addressImg: {
    marginRight: '8px',
    marginTop: '4px'
  },
  addressText: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#333333',
    wordBreak: 'break-word'
  },
  socialMediaCta: {
    background: theme?.palette?.primary?.main,
    border: 'none',
    borderRadius: '50%',
    width: '42px',
    height: '42px',
    cursor: 'pointer',
    margin: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: '0'
  },

  lowerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '24px 0 0 0'
  },
  bottomLeftText: {
    fontSize: '16px',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.font.primary
  },
  poweredDiv: {
    width: '15%',
    height: 'auto',
    position: 'relative',
    paddingBottom: ({ isCustomWebsite }) => (isCustomWebsite ? ' 6%' : '0%'),
    paddingTop: ({ isCustomWebsite }) => (isCustomWebsite ? ' 0%' : '1%'),
    '& p': {
      margin: '0',
      paddingRight: '8px',
      fontSize: '16px',
      lineHeight: '20px',
      textAlign: 'right',
      color: theme.palette.font.default
    },
    '& img': {
      width: '100px'
    }
  },

  poweredByContainer: {
    display: 'flex',
    width: '60%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px'
  },

  poweredDivImg: {
    width: '100px !important'
  },

  footerLogoImage: {
    objectFit: ({ isCustomWebsite }) => (isCustomWebsite ? 'contain' : ''),
    maxHeight: '55px'
  },

  '@media screen and (max-width: 767px)': {
    section: {
      padding: '16px 24px',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%'
    },
    upperContainer: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 24px'
    },
    upperContainerItem1: {
      width: '100%',
      justifyContent: 'center',
      padding: '0'
    },
    upperContainerItem2: {
      width: '100%',
      // justifyContent: 'center',
      padding: '60px 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start'
    },
    upperContainerItem3: {
      width: '100%',
      justifyContent: 'center'
    },
    cardHeading: {
      justifyContent: 'center',
      marginBottom: '8px'
    },
    addressContainer: {
      justifyContent: 'center'
    },
    addressText: {
      textAlign: 'center'
    },
    lowerContainer: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0'
    },
    poweredDiv: {
      // marginTop: '15px'
      width: '28%',
      paddingBottom: ({ isCustomWebsite }) => (isCustomWebsite ? '8%' : '0%')
    },

    socialMediaCta: {
      margin: '0 8px 16px 8px'
    },
    bottomLeftText: {
      padding: '48px 0 10px 0'
    },
    poweredByContainer: {
      gap: '2%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }
}));

export default useSectionStyles;
